import './DateRangeComparisonTitle.scss';
import { MdAdd, MdClose } from 'react-icons/md';
import { OverlayTrigger, Tooltip as BootstrapTooltip } from 'react-bootstrap';
import { CompanyFiscalCal } from '@blisspointmedia/bpm-types/dist/FiscalCalendar';
import { InteractiveDiv } from '@Components/InteractiveEl';
import { Placement } from '@Components/designConstants';
import { DateRange, formatDateLabel } from '@src/utils/date-utils';

interface DateRangeComparisonTitleProps {
  dates: DateRange;
  otherDates: DateRange;
  fiscalCal: CompanyFiscalCal;
  includeOtherDateRange: boolean;
  onShowComparison: () => void;
  onRemoveComparison: () => void;
}

// Shared "divider + date range (+ optional comparison date range)" title segment used by every
// chart that lets a user diff its primary date range against a comparison period (Daily Spend
// vs Impressions, Delivery Breakdown, Performance Breakdown). Centralizing this keeps the three
// call sites from drifting out of sync with each other, as they had (mismatched class-name
// casing against ChartContainer's actual DOM, inconsistent Placement usage).
export const DateRangeComparisonTitle = ({
  dates,
  otherDates,
  fiscalCal,
  includeOtherDateRange,
  onShowComparison,
  onRemoveComparison
}: DateRangeComparisonTitleProps) => (
  <>
    <div className='date-range-comparison-divider' />
    <div className='date-range-comparison-primary'>
      {`${formatDateLabel(dates.start, fiscalCal)} – ${formatDateLabel(dates.end, fiscalCal)}`}
    </div>
    {!includeOtherDateRange && (
      <OverlayTrigger
        placement={Placement.RIGHT}
        overlay={
          <BootstrapTooltip id='showComparisonPeriod'>Show comparison period</BootstrapTooltip>
        }
      >
        <InteractiveDiv className='date-range-comparison-add' onClick={onShowComparison}>
          <MdAdd />
        </InteractiveDiv>
      </OverlayTrigger>
    )}
    {includeOtherDateRange && (
      <>
        <div className='date-range-comparison-other'>
          {`vs ${formatDateLabel(otherDates.start, fiscalCal)} – ${formatDateLabel(
            otherDates.end,
            fiscalCal
          )}`}
        </div>
        <InteractiveDiv className='date-range-comparison-remove' onClick={onRemoveComparison}>
          <MdClose />
        </InteractiveDiv>
      </>
    )}
  </>
);
